export const CLOUD_STORAGE_BASE_URL =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_CLOUD_STORAGE_BASE_URL) ||
  process.env.REACT_APP_CLOUD_STORAGE_BASE_URL;

// Add fallback values
if (!CLOUD_STORAGE_BASE_URL) {
  console.error("CLOUD_STORAGE_BASE_URL is not defined");
}

export const PORTAL_WIFI_PATH =
  (typeof window !== "undefined" && window._env_?.REACT_APP_PORTAL_WIFI_PATH) ||
  process.env.REACT_APP_PORTAL_WIFI_PATH;
export const PORTAL_BROADBAND_PATH =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_PORTAL_BROADBAND_PATH) ||
  process.env.REACT_APP_PORTAL_BROADBAND_PATH;
export const PORTAL_FIBER_PATH =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_PORTAL_FIBER_PATH) ||
  process.env.REACT_APP_PORTAL_FIBER_PATH;
export const PORTAL_ETHERNET_PATH =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_PORTAL_ETHERNET_PATH) ||
  process.env.REACT_APP_PORTAL_ETHERNET_PATH;
export const PORTAL_PRIVATE_SERVICES_PATH =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_PORTAL_PRIVATE_SERVICES_PATH) ||
  process.env.REACT_APP_PORTAL_PRIVATE_SERVICES_PATH;

// Braintree Token
export const BRAINTREE_AUTH_TOKEN =
  (typeof window !== "undefined" && window._env_?.REACT_APP_BRAINTREE_TOKEN) ||
  process.env.REACT_APP_BRAINTREE_TOKEN;
export const BRAINTREE_AUTH_TOKEN_BRAZIL =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_BRAINTREE_TOKEN_BRAZIL) ||
  process.env.REACT_APP_BRAINTREE_TOKEN_BRAZIL;

// API Path for Web Portal
export const PORTAL_API_PATH =
  (typeof window !== "undefined" && window._env_?.REACT_APP_PORTAL_API_PATH) ||
  process.env.REACT_APP_PORTAL_API_PATH;

// API Path for Selfcare
export const SELFCARE_API_PATH =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_SELFCARE_API_PATH) ||
  process.env.REACT_APP_SELFCARE_API_PATH;

// Selfcare URL
export const SELFCARE_URL =
  (typeof window !== "undefined" && window._env_?.REACT_APP_SELFCARE_URL) ||
  process.env.REACT_APP_SELFCARE_URL;

// API Path for Pacing Engine
export const PACING_ENGINE_API_PATH =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_PACING_ENGINE_API_PATH) ||
  process.env.REACT_APP_PACING_ENGINE_API_PATH;

// Google Recaptcha Site Key
export const GOOGLE_RECAPTCHA_SITE_KEY =
  (typeof window !== "undefined" &&
    window._env_?.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY) ||
  process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
